stimulusApp.register(
  "cruise-voyage-card",
  class extends Stimulus.Controller {
    static targets = ["dates", "trigger"]

    toggle() {
      const opened = this.triggerTarget.getAttribute("aria-expanded") !== "true"

      this.triggerTarget.setAttribute("aria-expanded", opened)
      this.datesTarget.inert = !opened
      this.datesTarget.classList.toggle(
        "cruise-voyage-card--dates_opened",
        opened,
      )
    }
  },
)
